export default function beautifyUrl(link: string) {
    try {
        const url = new URL(link);

        let text;
        switch (url.hostname) {
            case "www.bitbucket.org":
            case "www.github.com":
            case "www.gitlab.com":
            case "bitbucket.org":
            case "github.com":
            case "gitlab.com": {
                const parts = url.hostname.split(".");
                text = parts[parts.length - 2];
                break;
            }
            case "www.twitter.com":
            case "twitter.com":
                text =
                    url.pathname.split("/")[1] ||
                    link.replace(/https?:\/\//, "");
                break;
            default:
                text = link.replace(/https?:\/\//, "");
                break;
        }

        return {
            url: link,
            text
        };
    } catch (_) {
        return null;
    }
}
